export default __webpack_public_path__ + "static/media/item1.9b843e74.png";